<template>
  <div class="main">
    <div class="top-box" v-if="tabTree && tabTree.length > 0">
      <div class="mainbg ok-bgcolor"></div>
      <!-- 搜索栏 -->
      <div class="search">
        <div class="search-input-div">
          <i class="iconfont icon-zu1741"></i>
          <input class="search-input" placeholder="请输入关键字" @click.stop="openPanel" />
        </div>
      </div>
      <div class="first-tab-wrap">
        <div class="first-tab">
          <div class="tab-card" :class="{ 'active': index == activeNum }" v-for="(item, index) in tabTree" :key="index"
            @click="clickFirstTab(index, item.id, item.type, item.code)">
            <img class="tab-icon" :src="item.ico" alt />
            <div class="title">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="second-tab-container">
        <van-tabs class="second-tab" v-model="activeIndex" @click="clickSecondTypes" swipe-threshold="2">
          <van-tab v-for="(secondItem, s) in secondType" :key="s" :title="secondItem.name" :name="s" class="title">
          </van-tab>
        </van-tabs>
      </div>

      <div class="child-type-wrap" v-if="thirdType && thirdType.length > 0">
        <ul class="child-type">
          <li :class="{ 'active': activeNum2 == t }" class="ok-btncolor" v-for="(thirdItem, t) in thirdType" :key="t"
            @click="clickThirdType(t, thirdItem.id, thirdItem.type, thirdItem.themeId)">{{ thirdItem.name }}</li>
        </ul>
      </div>
    </div>
    <div class="info-list">
      <!-- 资料类型 -->
      <packageList v-if="type == 1" ref="packageListRef" :code="code" :typeId="typeId" :themeId="themeId"></packageList>
      <!-- 海报类型 -->
      <posterCenter v-if="type == 2" :code="code" :typeId="typeId" :themeId="themeId" ref="posterCenterRef">
      </posterCenter>
      <!-- 文章，课件 -->
      <materialList v-if="type == 3 || type == 4" :code="code" :type="type" :typeId="typeId" :themeId="themeId"
        ref="materialListRef"></materialList>
      <!-- 卡片类型 -->
      <serviceGuide v-if="type == 5" :typeId="typeId" :code="code" :themeId="themeId" ref="serviceGuideRef">
      </serviceGuide>
      <!-- 视频类型/课件类型 -->
      <videoList v-if="type == 6" :code="code" :typeId="typeId" :themeId="themeId" ref="videoListRef"></videoList>
    </div>
  </div>
</template>
<script>
import { pageTools, common } from "@/api/mixins";
import materialList from "./components/materialList.vue";
import videoList from "./components/videoList.vue";
import posterCenter from "./components/posterCenter.vue";
import packageList from "./components/packageList.vue";
import serviceGuide from "./components/serviceGuide.vue";
import { share } from "@/api/mixins";
import bottomNav from "@/components/bottomNav";
export default {
  name: 'apps.newMaterial',
  mixins: [pageTools, common, share],
  data: () => ({
    typeId: "",
    type: "",
    tabTree: [],
    secondType: [], // 二级tab
    thirdType: [], // 三级tab
    activeNum: 0,//一级tab索引
    activeIndex: 0,//二级tab索引
    activeNum2: 0,//三级tab索引
    themeId: "",
    code: "",
    SecondTabCode: "",
    mechanId: "",
    userInfo: {
      headimgurl: "",
      nickname: ""
    }
  }),
  components: {
    materialList,
    videoList,
    packageList,
    serviceGuide,
    posterCenter,
    bottomNav
  },
  created() {
    console.log('created')
    if (!this.checkLogin()) {
      return;
    }
    this.getTypeTree();
    this.$app.hideRightIcon();
  },
  activated(){
    console.log('activated')
  },
  methods: {
    // 设置分享数据
    setShareConfig() {
      let link = location.href;
      const shareData = {
        title: "展业素材",
        link: link,
        content: "智能展业工具 实时热点素材",
        logo: `${location.origin}/apps/public/images/fx-logo.png`
      };
      console.log("shareData", shareData);
      this.shareInit(shareData, true);
    },
    // 获取分类树
    getTypeTree() {
      this.$http({
        url: "/app/information/queryLevelTree",
        type: "PUT",
        data: {}
      })
        .then(res => {
          this.tabTree = res.data;
          if (this.$route.query.code) {
            let firstIdx = res.data.findIndex(i => i.type == 2)
            let thdIdx = res.data[firstIdx].child.findIndex(i => i.code == this.$route.query.code)
            this.clickFirstTab(firstIdx, this.tabTree[firstIdx].id, this.tabTree[firstIdx].type, '', thdIdx);
          }else if(sessionStorage.getItem('materialActiveNum')){
            let activeNum = sessionStorage.getItem('materialActiveNum')
            let activeIndex = sessionStorage.getItem('materialActiveIndex')
            sessionStorage.removeItem('materialActiveNum')
            sessionStorage.removeItem('materialActiveIndex')
            this.activeIndex = activeIndex
            this.clickFirstTab(activeNum, this.tabTree[activeNum].id, this.tabTree[activeNum].type, '', activeIndex);
          } else if (this.tabTree[0]) {
            this.clickFirstTab(0, this.tabTree[0].id, this.tabTree[0].type);
          }
        })
        .catch(e => { });
    },
    // 一级tab
    clickFirstTab(index, id, type, code, thdIdx = 0) {
      this.activeNum = index;
      sessionStorage.setItem('materialActiveNum',index);
      // 二级分类tab
      this.secondType = [];
      this.thirdType = [];
      // 有下级分类进入下级分类tab
      if (this.tabTree[index].child && this.tabTree[index].child.length > 0) {
        this.secondType = this.tabTree[index].child;
        // 下级分类默认选中第一个tab
        console.log(thdIdx)
        this.clickSecondTypes(thdIdx || 0);
      } else {
        //如果没有二级标题,根据类型渲染页面
        this.typeId = id;
        this.type = type;
        this.themeId = this.secondType[index].themeId;
        this.code = code;
      }
    },
    clickSecondTypes(index) {
      console.log(index)
      this.thirdType = [];
      this.activeIndex =  +index;
      sessionStorage.setItem('materialActiveIndex',index);
      if (
        this.secondType[index].child &&
        this.secondType[index].child.length > 0
      ) {
        this.thirdType = this.secondType[index].child;
        // 三级分类没有code，使用二级分类得code
        this.SecondTabCode = this.secondType[index].code;
        this.clickThirdType(
          0,
          this.thirdType[0].id,
          this.thirdType[0].type,
          this.thirdType[0].themeId
        );
      } else {
        //如果没有三级标题,根据类型渲染页面
        this.typeId = this.secondType[index].id;
        this.type = this.secondType[index].type;
        this.themeId = this.secondType[index].themeId;
        this.code = this.secondType[index].code;
      }
    },
    clickThirdType(index, id, type, themeId) {
      this.activeNum2 = index;
      sessionStorage.setItem('materialActiveNum2',index);
      this.typeId = id;
      this.type = type;
      this.themeId = themeId;
      this.code = this.SecondTabCode;
    },
    openPanel() {
      sessionStorage.removeItem("searchPageInfo");
      this.$router.push({
        path: "/apps/newMaterial/searchPage",
        query: { showPanel: 1 }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
@import "./material.scss";
</style>
